module.exports = __webpack_public_path__ + "img/frog_half.403e9015.svg";